import { DumpsterLocationHistory } from "../../../models";

export const getDumpsterLocationHistory = (data: any): DumpsterLocationHistory => {
  return {
    id: data.id,
    createdAt: data.attributes.created_at,
    dumpsterId: data.attributes.dumpster_id,
    eventType: data.attributes.event_type,
    orderId: data.attributes.order_id || undefined,
    storageYardId: data.attributes.storage_yard_id || undefined,
    address: data.attributes.address || "",
    city: data.attributes.city || "",
    zip: data.attributes.zip || "",
  };
};

export const getDumpsterLocationHistoryList = (data: any): DumpsterLocationHistory[] => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map(getDumpsterLocationHistory);
};
